import localDB from "./localDB";

let GLOBAL = require('./globals');

const RecipeProductsPreMakeData = {
    async list(id) {
        let response = await fetch(`${GLOBAL.BASE_URL}api/products-premake-recipe/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async delete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}api/product-premake-recipe/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    async update(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/product-premake-recipe/${data.id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    async add(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/products-premake-recipe/${data.recipe}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    }
};

export default RecipeProductsPreMakeData;


// WEBPACK FOOTER //
// ./src/data/RecipeProductsPreMakeData.js